// extracted by mini-css-extract-plugin
module.exports = {"body":"_1GWglvBwq-NTEQ_Sk12yfr","dialog":"_27b2aPBFOQbYCaKQgwG2QJ"};